import { render, staticRenderFns } from "./batchAdjustmentOfOrders.vue?vue&type=template&id=11460d74&scoped=true&"
import script from "./batchAdjustmentOfOrders.vue?vue&type=script&lang=js&"
export * from "./batchAdjustmentOfOrders.vue?vue&type=script&lang=js&"
import style0 from "./batchAdjustmentOfOrders.vue?vue&type=style&index=0&id=11460d74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11460d74",
  null
  
)

export default component.exports